import React from 'react';
import './Partners.scss';
import { Col, Container, Row } from 'react-bootstrap';

export default function Partners() {
    return (
        <div id="Partners" className="partner-bg">
            <Container className="partner-div">
                <div className="text-center paddin-partner">
                    <div>
                        <h1 className="partner-title heading">Partners</h1>
                    </div>
                    <Row>
                        <Col xs={12} md={12} className="funds-label">
                            <Col xs={4} md={5} className="funds-label__left" />
                            <Col xs={4} md={2} className="funds">
                                <span>Funds</span>
                            </Col>
                            <Col xs={4} md={5} className="funds-label__right" />
                        </Col>
                    </Row>
                    <Row className="py-4 text-center">
                        <Col xs={6} md={3}>
                            <div className="py-5 ascensive" />
                        </Col>
                        <Col xs={6} md={3}>
                            <div className="py-5 moonrock" />
                        </Col>
                        <Col xs={6} md={3}>
                            <div className="py-5 divergence" />
                        </Col>
                        <Col xs={6} md={3}>
                            <div className="py-5 cms" />
                        </Col>
                    </Row>
                    <Row className="text-center">
                        <Col xs={6} md={4}>
                            <div className="py-5 morningstar" />
                        </Col>
                        <Col xs={6} md={4}>
                            <div className="py-5 genblock" />
                        </Col>
                        <Col xs={12} md={4}>
                            <div className="py-5 gvb" />
                        </Col>
                    </Row>

                    <Row className="mt-4">
                        <Col xs={12} md={12} className="funds-label">
                            <Col xs={4} md={5} className="funds-label__left" />
                            <Col xs={4} md={2} className="funds">
                                <span>Angels</span>
                            </Col>
                            <Col xs={4} md={5} className="funds-label__right" />
                        </Col>
                    </Row>
                    <Row className="py-4 text-center">
                        <Col xs={6} md={3}>
                            <div className="py-5 fran" />
                        </Col>
                        <Col xs={6} md={3}>
                            <div className="py-5 parafi" />
                        </Col>
                        <Col xs={6} md={3}>
                            <div className="py-5 f500" />
                        </Col>
                        <Col xs={6} md={3}>
                            <div className="py-5 archer" />
                        </Col>
                        {/* <Col xs={6} md={3}>
                            <div className="py-5 race" />
                        </Col> */}
                    </Row>
                    <Row className="text-center">
                        {/* <Col xs={6} md={6}>
                            <div className="py-5 archer" />
                        </Col> */}
                        <Col xs={12} md={12}>
                            <div className="py-5 oream" />
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    );
}
